import { render } from "./UserImpersonation.vue?vue&type=template&id=3bd7ac79&scoped=true"
import script from "./UserImpersonation.vue?vue&type=script&lang=js"
export * from "./UserImpersonation.vue?vue&type=script&lang=js"

import "./UserImpersonation.vue?vue&type=style&index=0&id=3bd7ac79&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd7ac79"]])

export default __exports__